// Tile jalan Leaflet: URL sama persis di kedua tema, gelap cuma nambah className buat di-filter CSS. Murni, nol import.

const GOOGLE_LIGHT = {
  url: 'https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&gl=id&hl=id',
  options: { maxZoom: 19, attribution: 'Map data © Google Maps' },
};

const OSM_LIGHT = {
  url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  options: { maxZoom: 19, attribution: '&copy; OpenStreetMap contributors' },
};

export function roadTileLayer(theme, source = 'osm') {
  const base = source === 'google' ? GOOGLE_LIGHT : OSM_LIGHT;
  if (theme !== 'dark') return base;
  return { url: base.url, options: { ...base.options, className: 'mz-tiles-dark' } };
}

// Ganti layer jalan pas tema berubah: lepas yang lama (kalau lagi nempel di map), pasang yang baru.
// L di-inject biar gak nyantol ke global Leaflet, tetep gampang dites.
export function swapRoadLayer(L, map, layer, theme, source) {
  if (map && layer) map.removeLayer(layer);
  const { url, options } = roadTileLayer(theme, source);
  const nextLayer = L.tileLayer(url, options);
  if (map) nextLayer.addTo(map);
  return nextLayer;
}

export default roadTileLayer;
